<template>
  <div class="app-container top-padding" uk-height-viewport="expand: true">
    <div v-if="authenticated && hasAdminRole">
    <div class="uk-position-center" v-if="getPendingQueueLoading || getDeclinedQueueLoading">
      <spinner></spinner>
    </div>
        <div v-else class="uk-width-1-1" uk-grid>
          <div class="uk-width-1-4">
            <resource-menu
              :moderation="true"
              :newDeclinedResources="newDeclinedResources"
              :newPendingResources="newPendingResources"
              :declinedResources="declinedResources.length"
              :pendingResources="pendingResources.length"
              :selectedItem="selectedResourceState"
              @onClick="setSelectedModerationQueue">
            </resource-menu>
            <!--          <moderation-filters-->
            <!--            v-for="(filters, index) in resolvedFilters"-->
            <!--            :key="index"-->
            <!--            :state="selectedResourceState"-->
            <!--            :filters="filters"-->
            <!--            @onOptionSelected="optionSelected">-->
            <!--          </moderation-filters>-->
          </div>
          <div class="uk-width-3-4">
            <pagination
              :currentPage="currentPage"
              :nextEnabled="nextEnabled"
              @fetchNextBatch="next"
              @fetchPreviousBatch="previous"
              class="uk-align-right">
            </pagination>
            <div>
              <pending-resources
                :loading="getPendingQueueLoading"
                :resources="pendingResources"
                v-if="getPendingQueueSelected">
              </pending-resources>
              <declined-resources
                :loading="getDeclinedQueueLoading"
                :resources="declinedResources"
                v-if="getDeclinedQueueSelected">
              </declined-resources>
            </div>
          </div>
        </div>
      </div>
    <div v-else>
      <moderator-access :hasAccess="hasAdminRole" :loggedIn="authenticated"></moderator-access>
    </div>
  </div>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import ModeratorAccess from './moderator-access'
  import moderationFilters from './moderation-filters'
  import resourceMenu from '../manage-resources/navigation/menu'
  import * as moderationStatus from '../../../enums/moderation-status'
  import * as misc from '../../../enums/misc'
  import pagination from '../../search/pagination'
  import declinedResources from './declined-resources'
  import pendingResources from './pending-resources'
  import dateUtil from '../../../utils/date-util'
  import * as idStore from '../../../enums/id-store-keys'
  import * as _ from 'lodash'
  import resourceSearch from '../../../utils/resource-search-util'
  import * as countries from '../../../enums/supported-countries'
  import spinner from '../../ui-components/spinner/spinner'

  export default {
    name: 'moderate-resources',
    components: {
      moderationFilters,
      ModeratorAccess,
      resourceMenu,
      pagination,
      declinedResources,
      pendingResources,
      spinner
    },
    props: ['loadState'],
    data() {
      return {
        lastPulledDate: null
      }
    },
    methods: {
      ...mapMutations(['setSelectedModerationQueue', 'setModerationResourcePage', 'setModerationQueue', 'setModerationQueueDefaults', 'setLocationFilter']),
      ...mapActions(['fetchModerationQue', 'fetchIDData', 'storeIDData', 'updateLocationFilter']),
      next() {
        switch (this.selectedResourceState) {
          case moderationStatus.PENDING:
            this.setModerationResourcePage({status: moderationStatus.PENDING, page: this.getPendingQueuePage + 1})
            break
          case moderationStatus.DECLINED:
            this.setModerationResourcePage({status: moderationStatus.DECLINED, page: this.getDeclinedQueuePage + 1})
        }
      },
      previous() {
        switch (this.selectedResourceState) {
          case moderationStatus.PENDING:
            this.setModerationResourcePage({status: moderationStatus.PENDING, page: this.getPendingQueuePage - 1})
            break
          case moderationStatus.DECLINED:
            this.setModerationResourcePage({status: moderationStatus.DECLINED, page: this.getDeclinedQueuePage - 1})
        }
      },
      resolveModerationQueue() {
        this.fetchModerationQue({status: moderationStatus.PENDING.toUpperCase(), nextPageToken: null})
        this.fetchModerationQue({status: moderationStatus.DECLINED.toUpperCase(), nextPageToken: null})
      },
      fetchLastPulledDate() {
        this.fetchIDData()
          .then(result => {
            let store = result.body
            if (!_.isEmpty(store)) {
              for (let key in store) {
                if (key === idStore.LAST_PULLED) {
                  this.lastPulledDate = store[key]
                }
              }
            }
          })
      },
      storeLastPulledDate() {
        let keyValue = {[idStore.LAST_PULLED]: Date.now()}
        this.storeIDData(keyValue)
      },
      resolveLocation(country) {
        let title = countries.SUPPORTED_COUNTRIES.find(c => c.ID === country).title
        let countriesList = this.$t('countries')
        return countriesList[title]
      },
      optionSelected(selected) {
        let currentOptions = this.getModerationFilters.filter(f => f.title === selected.filter)
        let updates = currentOptions[0].items.map(option => {
          if (option.title === selected.title) {
            if (option.selected) {
              option.selected = false
            } else {
              option.selected = true
            }
          }
          return option
        })
        switch (this.selectedResourceState) {
          case moderationStatus.PENDING:
            this.setLocationFilter({locations: updates, status: 'pending'})
            break
          case moderationStatus.DECLINED:
            this.setLocationFilter({locations: updates, status: 'declined'})
            break
        }
      }
    },
    computed: {
      ...mapGetters(['hasAdminRole', 'getPendingSelected', 'getDeclinedSelected', 'getDeclinedResourcesQueueTotal', 'getPendingResourcesQueueTotal', 'getPendingQueueSelected', 'getDeclinedQueueSelected', 'getPendingQueueLoading', 'getDeclinedQueueLoading', 'getPendingResourcesQueue', 'getDeclinedResourcesQueue', 'getPendingQueuePage', 'getDeclinedQueuePage', 'searchTerm', 'getModerationFilters']),
      ...mapGetters('auth/id', ['authenticated']),
      selectedResourceState() {
        if (this.getPendingQueueSelected) {
          return moderationStatus.PENDING
        } else if (this.getDeclinedQueueSelected) {
          return moderationStatus.DECLINED
        }
      },
      currentPage() {
        switch (this.selectedResourceState) {
          case moderationStatus.PENDING:
            return this.getPendingQueuePage
          case moderationStatus.DECLINED:
            return this.getDeclinedQueuePage
        }
      },
      nextEnabled() {
        switch (this.selectedResourceState) {
          case moderationStatus.PENDING:
            return this.pendingResources.length > this.getPendingQueuePage * misc.PAGING_SIZE
          case moderationStatus.DECLINED:
            return this.declinedResources.length > this.getDeclinedQueuePage * misc.PAGING_SIZE
        }
      },
      newPendingResources() {
        for (let item of this.getPendingResourcesQueue) {
          return dateUtil.compareTime(this.lastPulledDate, item.lastModTime)
        }
      },
      newDeclinedResources() {
        for (let item of this.getDeclinedResourcesQueue) {
          return dateUtil.compareTime(this.lastPulledDate, item.lastModTime)
        }
      },
      pendingResources() {
        let locationFilters = this.getModerationFilters.filter(f => f.title === 'pending locations')[0].items.filter(filter => {
          if (filter.selected === true) {
            return filter
          }
        })
        return resourceSearch.resolve(this.getPendingResourcesQueue, this.searchTerm, locationFilters)
      },
      declinedResources() {
        let locationFilters = this.getModerationFilters.filter(f => f.title === 'declined locations')[0].items.filter(filter => {
          if (filter.selected === true) {
            return filter
          }
        })
        return resourceSearch.resolve(this.getDeclinedResourcesQueue, this.searchTerm, locationFilters)
      },
      resolvedFilters() {
        switch (this.selectedResourceState) {
          case moderationStatus.PENDING:
            return this.getModerationFilters.filter(f => f.title === 'pending locations')
          case moderationStatus.DECLINED:
            return this.getModerationFilters.filter(f => f.title === 'declined locations')
        }
      }
    },
    watch: {
      getPendingResourcesQueue(resources) {
        let status = 'pending'
        let locations = resources.map(resource => {
          return resource.country
        })
        this.updateLocationFilter({locations, status})
      },
      getDeclinedResourcesQueue(resources) {
        let status = 'declined'
        let locations = resources.map(resource => {
          return resource.country
        })
        this.updateLocationFilter({locations, status})
      }
    },
    created() {
      this.fetchLastPulledDate()
      this.setModerationQueueDefaults()
      this.resolveModerationQueue()
      this.storeLastPulledDate()
    }
  }
</script>

<style lang="scss" scoped>
  @import '../../../../src/styles/breakpoints';
  @import '../../../../src/styles/colours';

  .top-padding {
    padding-top: 86px;
  }

  @media screen and (max-width: $breakpoint-medium) {
    .app-container {
      width: 100%;
    }

    .top-padding {
      padding-top: 115px;
    }
  }
</style>
